import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Grid, Link, Typography } from "@mui/material";
import { format } from "date-fns";
import { baseTheme } from "../../../themes/shipinsure";
import { getTrackingUrl } from "../getTrackingUrl";

const META_TEXT = "#1E293B";

export function OrderAndClaimDetails({ claim, t }) {
  const orderDate = claim.order?.ordered_at || claim.order?.created_at;
  const actualResolution = claim.claim_resolution || claim.preferred_resolution;
  const description = claim.additional_info || "";
  const trackingUrl = getTrackingUrl(claim.claim_number);

  return (
    <Box
      mb="16px"
      sx={{
        border: "1px solid #C5D0E0",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: baseTheme.colors.neutral,
      }}
    >
      <Typography
        fontWeight={700}
        mb="16px"
        fontSize="1.05rem"
        color={baseTheme.colors.text}
      >
        {t("status.details")}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Detail
            label={t("status.orderNumber")}
            value={`#${claim.order_number}`}
            breakAll
          />
          {trackingUrl ? (
            <Link
              href={trackingUrl}
              target="_blank"
              rel="noreferrer"
              underline="hover"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                mt: "6px",
                fontSize: "14px",
                fontWeight: 600,
                color: baseTheme.colors.primary,
              }}
            >
              {t("status.viewTracking")}
              <OpenInNewIcon sx={{ fontSize: 14 }} />
            </Link>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Detail
            label={t("status.orderDate")}
            value={
              orderDate ? format(new Date(orderDate), "MMMM d, yyyy") : "—"
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Detail
            label={t("status.claimDate")}
            value={format(new Date(claim.created_at), "MMMM d, yyyy")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Detail label={t("status.reason")} value={claim.reason} capitalize />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Detail
            label={t("status.resolution")}
            value={claim.preferred_resolution}
            capitalize
          />
        </Grid>
        {claim.claim_resolution ? (
          <Grid item xs={12} sm={6}>
            <Detail
              label={t("status.actualResolution")}
              value={actualResolution}
              capitalize
            />
          </Grid>
        ) : null}
      </Grid>

      {description ? (
        <Box
          mt="16px"
          pt="16px"
          sx={{ borderTop: "1px solid #E2E8F0" }}
        >
          <Typography
            fontWeight={700}
            fontSize="14px"
            color={META_TEXT}
            mb="6px"
          >
            {t("status.description")}
          </Typography>
          <Typography
            fontSize="15px"
            color={baseTheme.colors.text}
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              lineHeight: 1.65,
            }}
          >
            {description}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

function Detail({ label, value, capitalize = false, breakAll = false }) {
  return (
    <Box>
      <Typography fontWeight={700} fontSize="14px" color={META_TEXT} mb="2px">
        {label}
      </Typography>
      <Typography
        fontSize="15px"
        color={baseTheme.colors.text}
        textTransform={capitalize ? "capitalize" : "none"}
        sx={breakAll ? { wordBreak: "break-all" } : undefined}
      >
        {value || "—"}
      </Typography>
    </Box>
  );
}
